import { Analytics, getAnalytics, logEvent } from "firebase/analytics";

import { ANALYTICS_CONFIG } from "./config";

// Firebase Analytics instance
let analytics: Analytics | null = null;

// Initialize Firebase Analytics
export const initAnalytics = () => {
  if (!ANALYTICS_CONFIG.enabled) {
    console.warn("Analytics disabled");
    return;
  }

  try {
    analytics = getAnalytics();
    console.log("Firebase Analytics initialized");
  } catch (error) {
    console.error("Failed to initialize Firebase Analytics:", error);
  }
};

// Track custom events
export const trackEvent = (
  eventName: string,
  parameters?: {
    event_category?: string;
    event_label?: string;
    value?: number;
    [key: string]: any;
  }
) => {
  if (!analytics) return;

  logEvent(analytics, eventName, parameters);
};

// Track user engagement
export const trackEngagement = (action: string, category: string, label?: string) => {
  trackEvent("engagement", {
    event_category: category,
    event_label: label,
    action: action
  });
};
